import React from 'react'

export default function Search() {
    return (
        <div>
            Search
        </div>
    )
}
